var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('dataplat-search',{ref:"dataplatSearch",on:{"submit":_vm.handleSubmit}}),_c('dataplat-content',{attrs:{"columns":_vm.tableColumns,"list":_vm.tableList,"total":_vm.total},on:{"changePage":_vm.handleChangePage,"changePageSize":_vm.handleChangePageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }